/**
 * Csv Schema of StatusCarga
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {StatusCarga} from '@/model/resource/StatusCarga'

/* TODO: review generated schema */
export class CsvStatusCargaSchema extends Schema {
  readonly name = 'CsvStatusCarga'

  readonly fieldSet: FieldSet<StatusCarga> = {
    idStatusPk: schema => schema.model.idStatusPk,
    nome: schema => schema.model.nome,
    ativo: schema => Helper.bool(schema.model.ativo),
  }
}
